import * as localforage from 'localforage';

const store = localforage.createInstance({
  driver: localforage.LOCALSTORAGE,
  name: 'injobnito',
  version: 1.0,
});

export const storageService = {
  getItem: (key) => {
    return store.getItem(key);
  },
  setItem: (key, value) => {
    return store.setItem(key, value);
  },
  removeItem: (key) => {
    return store.removeItem(key);
  },
};
